import { HeaderComponent } from 'src/scripts/sections/header'
import { ModalComponent } from '../modal'
import { $el, $list, delay } from 'src/scripts/utils/utils'
import { replaceNodeChildren } from 'src/scripts/utils/dom'
import { isMobile } from 'src/scripts/utils/check-media'

const HEADER_SELECTOR = 'header-component'
const HEADER_WITH_POPUP_CLASS = 'shopify-section-header--with-cart-popup'

export class CartNotificationPopup extends ModalComponent {
  wasHeaderHidden: boolean

  purchaseHandler(html, parsedState): void {
    const header: HeaderComponent = $el(HEADER_SELECTOR)
    this.wasHeaderHidden = header.isHidden

    if (this.element) {
      const newNode = $el(`#CartNotificationPopupItem-${parsedState.id}`, html)
      const node = $el('[data-cart-notification-popup]', this.element)

      replaceNodeChildren(node, newNode)

      this.toggleMobileHeader(false).then(() => {
        this.show()
      })
    }
  }

  async hide() {
    await super.hide()

    if (this.wasHeaderHidden) {
      this.toggleMobileHeader(true)
    }
  }

  toggleMobileHeader = async (isToShow: boolean): Promise<void> => {
    if (isMobile()) {
      const header: HeaderComponent = $el(HEADER_SELECTOR)

      header.setHidden(isToShow)
      header.parentElement.classList.toggle(HEADER_WITH_POPUP_CLASS, !isToShow)

      await delay(300)
    }
  }
}
